<template lang="pug">
modal(name='addprocedures', id="addmodal" @before-open="beforeOpen"  transition='pop-up', :width="'720px'", height='720px')
  n-button.closedialog(@click.native="closeModal()") ❌ 
  .mr-auto 
    span.modaltitle Create Procedure
    .card
      .card-body.center
        .addform
          vue-form(:state="formstate")
            fieldset()
              validate(tag="label")
                span.title(v-tooltip="")  Procedure Code
                //multiselect(:options="sampleOptions" v-model="sampleValue" :multiple="false" name="select")
                multiselect( name="codes",  v-model="value.code", :options="proceduresArr", multiple=false, taggable=false, closeOnSelect=true,  showLabels=false, placeholder="search prodedure codes and names", label="label",  track-by="label")
                  template(slot="maxElements" slot-scope="props") 
                    span(class="multiselect__option" style="float: left;") 
              validate(tag="label")
                span.title(v-tooltip="") Procedure Name
                fg-input(autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="value.name" name="name" type="" required=true placeholder="")
              validate(tag="label")
                span.title(v-tooltip="") Procedure Type
                fg-input(autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="value.type" name="type" type="" required=true placeholder="")
              validate(tag="label")
                span.title(v-tooltip="") Procedure Stage
                multiselect( name="stage",  v-model="value.stage", :options="stagesArr", :multiple="false", :close-on-select="true", placeholder="select current stage", :preselect-first="false", open-direction="bottom")
              validate(tag="label")
                span.title(v-tooltip="") Procedure Detail
                textarea.detail(autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="value.detail" name="detail" type="" required="" placeholder="")
              validate(tag="label")
                span.title(v-tooltip="") Status
                multiselect( name="status",  v-model="value.status", :options="statusArr", :multiple="false", :close-on-select="true", placeholder="select current status", :preselect-first="false", open-direction="bottom")
              validate(tag="label")
                span.title(v-tooltip="") Inactive Date
                fg-input(autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="value.inactive" name="inactive" type="date" required=true placeholder="01/01/2020")
        span.export.nav-item.lookup(to='/login')
          a.nav-link.btn.btn-primary.login(v-on:click="$eventBus.$emit('log', 'submit')")
            p Save
      div.right.btnright.top
        div.create.nav-item.lookup(to='/login') 
          a.nav-link.btn.btn-primary.login(v-on:click="$eventBus.$emit('log', 'create')")
            p Policies
            p.label Attach Policies
      div.right.btnright.bottom
        div.import.nav-item.lookup(to='/login')
          a.nav-link.btn.btn-primary.login(v-on:click="$eventBus.$emit('log', 'import')")
            p Instructions
            p.label Attach Instructions
</template>
<script>
import { Card, Button, FormGroupInput, Checkbox } from '@/components'
import {
    Switch
} from 'element-ui'
export default {
  name: 'EditSamplesModal',
  props: ['text'],
  components: {
      [Button.name]: Button,
      [Card.name]: Card,
      [Switch.name]: Switch,
      [Checkbox.name]: Checkbox,
          [FormGroupInput.name]: FormGroupInput
            },
  data() { 
    return {
    button: 'OK',
    codesArray: [],
    title: '',
    value: { status: '', stage: '', code: '' },
    username: this.$store.getters.get('user').username,
    groupSelect: false,
    sampleValue: null,
    editsample: false,
    formDisabled: false,
    sampleDisabled: false,
    formstate: {},
    running: false,
		form: { agree: false },
    model : {},
    newSample: {
      public: 0,
      group: 'test',
      sample: 'test',
      ethnicity: 'test',
      description: 'test',
      age: 2019,
      origin: 'test',
      coords: '',
      coords2: '',
    }
    }
  },
  computed: {
    module: function() { return  (this.$store.getters.get('module') ) },
    changes: function() { return  this.$store.getters.get('changes') },
    proceduresArr: function() { return this.$store.getters.get('proceduresArr') },
    statusArr: function() { return this.$store.getters.get('statusArr') },
    stagesArr: function() { return this.$store.getters.get('stagesArr') },
    initData: function() {
    var data = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
    return data;
    },
  model2: function() {
  return this.initData[0]
  }
  },
  methods: {
    closeModal: function() {
    this.$modal.hide('addprocedures');
    },
      beforeOpen (event) {
          if ( event.params.action === 'info' || event.params.action === 'edit' ) {
          this.model = this.initData[event.params.index]
          if ( event.params.action === 'info' ) {
          this.button = 'OK'
          this.title = '';
          this.formDisabled = true;
          } else {
          this.title = 'Edit'
          this.button = 'Modify'
          this.formDisabled = false;
          this.sampleDisabled = true;
          }
          } else {
          this.formDisabled = false;
          this.sampleDisabled = false;
          this.button = 'Add'
          this.model = {}
          this.title = 'Add'
          }
          },
		feature: function(el) {
            this.$eventBus.$emit('appEvents', {
                exec: 'featureRequest',
                component: 'g25',
                params: el
            })
		},
    onSubmit: function() {
      if(this.formstate.$invalid) {
        // alert user and exit early
            this.$eventBus.$emit('appEvents', {
                exec: 'show',
                component: 'nav',
                params: {
                    title: 'Error',
                    text: 'Please fill in all required fields',
                    class: 'failure'
                }
            })
        return;
      } else {
    var changes = {...this.changes}
    var data = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
    if ( this.model.index >=0 ) {
    this.model.action = 'update'
    data.splice(this.model.index, 1, this.model )
    } else {
    var index = data.length;
    this.model.index = index;
    this.model.action = 'insert'
    data.push(this.model);
    }
    changes[this.model.sample] = this.model
    this.$store.commit('change', { changes: changes })
    this.$store.commit('change', { editSamples: data })
    this.$modal.hide('addprocedures');
		}
    },
    validatePeriod: function (value) {
    if ( parseInt(value) <= new Date().getFullYear() && parseInt(value) >= -100000 ) {
    return true
    } else {
    return false
    }
    },
    validateCoords: function (value) {
    var coords = value.split(",");
    if ( coords.length !== 25 || coords.findIndex(n => parseInt(n) !== 0) >= 0 ) {
    return false 
    } else {
    return true
    }
    },
  uniqueSampleName: function (value) {
    var index = this.initData.findIndex( sample => sample.sample === value )
		if ( value.indexOf(' ') >= 0 || (index >= 0 && !this.formDisabled && !this.sampleDisabled)) {
		return false
			} else {
    return true
		}
  }
  }
}
</script>
<style>

#app span.modaltitle {
    position: absolute;
    top: 10px;
    width: 100%;
    text-align: center;
    z-index: 1;
    font-weight: 700;
    font-size: 20px;
    padding-top: 10px;
    color: #055258;
}

#addmodal ::placeholder {
font-weight: 400;
}

#addmodal fieldset[disabled] .form-control {
background-color: #ffffff;
}

#addmodal .multiselect__input, .multiselect__single {
    position: relative;
    display: inline-block;
    min-height: 20px;
    line-height: 20px;
    border: none;
    border-radius: 5px;
    background: #fff;
    padding: 0 0 0 8px;
    width: 100%;
    -webkit-transition: border .1s ease;
    transition: border .1s ease;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 8px;
    vertical-align: top;
    font-weight: 700;
    color: #1f7bb3;
}
#addmodal textarea.detail {
    width: 100%;
    height: 100px;
    border-radius: 9px;
    padding: 10px 18px;
    font-size: 16px;
    color: #1f7bb3;
    font-weight: 799;
    border-color: #80808042;
}

#addmodal input.vf-valid {
color: #096b94;
font-weight: 700;
font-size: 16px;
}
#addmodal .form-control {
border-radius: 7px;
}
#addmodal input.vf-invalid {
color: brown;
font-weight: 700;
font-size: 16px;
}
#addmodal .form-control[disabled] {
background-color: white;
    color: #999;
        font-size: 1em;
            margin-left: 15px;
                cursor: not-allowed;
                }

#addmodal fieldset[disabled] .btn-primary:disabled {
display: none;
}
.v--modal button.closedialog {
    background: transparent;
    position: absolute;
    top: 0px;
    right: 0px;
    display: inline;
    float: right;
    z-index: 9;
}
#app #addmodal .v--modal button.closedialog:hover {
box-shadow: none;
}
#app #addmodal .v--modal button.closedialog:active {
background: #9797971c;
}
span.modaltitle {
    position: absolute;
    top: 10px;
    width: 100%;
    text-align: center;
    z-index: 1;
    font-weight: 700;
    font-size: 20px;
    padding-top: 10px;
    color: #0f5579;
}
.infomsg, .validmsg, .errmsg {
font-size: 0.9em;
text-align: left;
padding-left: 20px;
color: #a2a2a2;
}
.errmsg {
color: rgba(255,0,0,0.7);
}
#addmodal .v--modal-box {
margin-top: 0px;
}

#addmodal .fas.fa-check {
color: green;
}

#addmodal .mr-auto {
height: 100%;
}
#addmodal .card {
height: 100%;
}
#addmodal .el-switch {
height: 46px;
padding-bottom: 10px;
}
div.settings {
    display:grid;
    grid-template-columns: max-content max-content;
    grid-gap:5px;
}
div.settings label       { text-align:right; }
div.settings label:after { content: ":"; }
label {
width: 70%;
margin-left: 30%;
}
#addmodal .addrawdna:hover {
    opacity: 1;
    }
#addmodal .addrawdna {
    opacity: 0.7;
    background-color: white !important;
    color: #206096;
    font-size: 16px;
    border: 1px solid #206096;
font-size: 16px;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 8px;
    left: 23px;
box-shadow: none;
z-index: +9;
}
#addmodal span.title {
font-weight: 400;
    padding-top: 8px;
    position: absolute;
    right: 72%;
    text-align: right;
    z-index: 1;
}
#app #addmodal span.subtext {
    font-weight: 400;
    font-size: 20px;
    padding-top: 3px;
    position: absolute;
    width: 30%;
    left: 0px;
    color: brown;
    text-align: right;
}

#app #addmodal .card {
padding: 50px 20px;
}

#addmodal .break>input {
    word-wrap: break-word;
    word-break: break-all;
    height: 80px;
}

#app .addform label {
    width: 70%;
        margin-left: 26%;
        }
        
#app #addmodal .addform span.title {
    font-weight: 400;
    padding-top: 8px;
    position: absolute;
    right: 75%;
    text-align: right;
    z-index: 1;
}
 body.home .card-body.right {
     border-left: 1px solid white;
         width: 40%;
         padding-right: 20px;
         }
body.home #app .card-body.center a.nav-link.btn.btn-primary.login {
position: absolute;
    bottom: 33px;
    left: 50px;
        }
body.home #appa .card-body a.nav-link.btn.btn-primary.login {
width: 100px;
position: relative;
left: 220px;
}

body.home #app div.right.btnright a.nav-link.btn.btn-primary.login {
width: 120px;
}
body.home #app div.right.btnright {
    width: 100%;
        height: 80px;
            padding-right: 32px;
            }

body.home #app div.right.btnright.top {
margin-top: 56px;
}


body.home #app div.right.btnright .lookup  {
float: right;
}

body.home #app div.right.btnright a.nav-link.btn.btn-primary.login {
background-color: #098b5b !important;
}
body.home #app .addform {
    margin-top: 30px;
        margin-bottom: -30px;
        }
body.home #app div.right.btnright a.nav-link.btn.btn-primary.login .label {
position: relative;
    color: gray;
        text-align: right;
            right: 230px;
            width: 200px;
                top: -38px;
                    font-weight: 400;
                    }

</style>
